import React from 'react';
import { LayoutDashboard, UserPlus, Scissors, LogOut } from 'lucide-react';
import { cn } from '../../lib/utils';
import { UserProfile } from '../../types';

interface NavbarProps {
  user: UserProfile | null;
  onLogin: (role?: string) => void;
  onLogout: () => void;
  onTabChange: (tab: string) => void;
  activeTab: string;
}

export const Navbar = ({ user, onLogin, onLogout, onTabChange, activeTab }: NavbarProps) => (
  <nav className="bg-slate-900/80 backdrop-blur-xl text-white sticky top-0 z-50 px-4 py-3 border-b border-white/10 shadow-xl shadow-slate-900/10">
    <div className="max-w-7xl mx-auto flex items-center justify-between">
      <div 
        className="flex items-center gap-3 cursor-pointer group" 
        onClick={() => onTabChange('home')}
      >
        <div className="bg-emerald-500 p-2.5 rounded-2xl shadow-lg shadow-emerald-500/20 group-hover:rotate-12 transition-transform duration-500">
          <Scissors className="w-5 h-5 text-white" />
        </div>
        <div className="flex flex-col">
          <span className="text-xl font-black tracking-tighter leading-none">CukurJe</span>
          <span className="text-[10px] font-bold text-emerald-500 uppercase tracking-widest hidden sm:block">Digital Barbering</span>
        </div>
      </div>
 
          <div className="flex items-center gap-2 sm:gap-6">
        {user ? (
          <div className="flex items-center gap-3 sm:gap-6">
            <div className="flex items-center gap-1 bg-white/5 p-1 rounded-2xl border border-white/5">
              <button 
                onClick={() => onTabChange(user.role === 'admin' ? 'admin-dashboard' : user.role === 'barber' ? 'dashboard' : 'my-bookings')}
                className={cn(
                  "px-3 sm:px-6 py-2 rounded-xl flex items-center gap-2 transition-all text-[10px] sm:text-xs font-bold",
                  (activeTab === 'dashboard' || activeTab === 'my-bookings' || activeTab === 'admin-dashboard') 
                    ? "bg-white text-slate-900 shadow-md" 
                    : "text-slate-400 hover:text-white hover:bg-white/5"
                )}
              >
                <LayoutDashboard className="w-4 h-4" />
                <span className="hidden xs:inline">DASHBOARD</span>
                <span className="xs:hidden">DASH</span>
              </button>
              {user.role === 'customer' && (
                <button 
                  onClick={() => onTabChange('register-barber')}
                  className={cn(
                    "px-6 py-2 rounded-xl flex items-center gap-2 transition-all text-xs font-bold",
                    activeTab === 'register-barber' 
                      ? "bg-white text-slate-900 shadow-md" 
                      : "text-slate-400 hover:text-white hover:bg-white/5"
                  )}
                >
                  <UserPlus className="w-4 h-4" />
                  JADI KAPSTER
                </button>
              )}
            </div>

            <div className="flex items-center gap-3 pl-6 border-l border-white/10">
              <div className="relative">
                <img src={user.avatar} alt="Avatar" className="w-10 h-10 rounded-2xl border-2 border-white/20 object-cover shadow-lg" />
                <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-emerald-500 border-2 border-slate-900 rounded-full" />
              </div>
              <div className="hidden sm:block">
                <p className="text-sm font-black leading-none">{user.name}</p>
                <p className="text-[9px] font-bold text-slate-500 uppercase tracking-widest mt-1">
                  {user.role === 'barber' ? 'KAPSTER PROFESIONAL' : user.role.toUpperCase()}
                </p>
              </div>
              <button 
                onClick={onLogout}
                className="ml-2 p-3 bg-white/5 hover:bg-red-500 hover:text-white rounded-2xl transition-all text-slate-400 active:scale-95 shadow-lg border border-white/5"
                title="Log Out"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </div>
          </div>
        ) : (
          <div className="flex items-center gap-2 sm:gap-4">
            <button 
              onClick={() => onTabChange('login')}
              className="text-white/60 hover:text-white px-3 sm:px-5 py-2 text-xs font-black uppercase tracking-widest transition-colors cursor-pointer"
            >
              Masuk
            </button>
            <button 
              onClick={() => onTabChange('register-barber')}
              className="bg-emerald-500 hover:bg-emerald-600 text-white px-5 sm:px-8 py-3.5 rounded-2xl text-xs font-black uppercase tracking-widest transition-all shadow-xl shadow-emerald-500/20 active:scale-95 border border-emerald-400/20 cursor-pointer"
            >
              Jadi Kapster
            </button>
          </div>
        )}
      </div>
    </div>
  </nav>
);
